import React, { memo, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';

import useResponsive from '../../../../../hooks/useResponsive';
import { getCountryId } from '../../../../MarketplaceModule/store/products/products.selectors';
import { findItemById } from '../../../../../helpers/list.helpers';
import { getCountries } from '../../../../../store/countries/countries.selectors';

const useStyles = makeStyles(({ palette }) => ({
  countryName: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 1.25,
    color: palette.primary.main,
  },
  countryNameMobile: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.25,
    color: palette.primary.main,
  },
  countryFlag: {
    width: 24,
    height: 24,
  },
  countryFlagMobile: {
    width: 14,
    height: 14,
  },
}));

const MarketplacePageTitle = () => {
  const classes = useStyles();
  const { isMobile } = useResponsive();
  const countryId = useSelector(getCountryId);
  const countries = useSelector(getCountries);
  const filterCountry = useMemo(() => findItemById(countryId)(countries), [countryId, countries]);
  return (
    <Box width={1} height={[60, 80]} display="flex" alignItems="center" justifyContent="center" fontFamily="Lato">
      <Box mr={1}>
        <img
          className={isMobile ? classes.countryFlagMobile : classes.countryFlag}
          src={filterCountry ? filterCountry.image : ''}
          alt={`${filterCountry ? filterCountry.name : ''} flag`}
        />{' '}
      </Box>
      <Box>
        <Typography className={isMobile ? classes.countryNameMobile : classes.countryName}>
          {filterCountry ? filterCountry.name : ''} Marketplace
        </Typography>
      </Box>
    </Box>
  );
};

export default memo(MarketplacePageTitle);
